export default function TrustBar() {
  const trustSignals = [
    "Built for Philippine Warehouses",
    "GS1 Barcode Ready",
    "Lot Traceability",
    "FIFO Enforcement",
    "Enterprise Security"
  ]

  return (
    <section className="bg-white border-y border-navy-100">
      <div className="container-custom py-8 md:py-12">
        <p className="text-center text-sm font-medium text-navy-500 uppercase tracking-wide mb-6">
          Built for Philippine warehouses, distribution centers, and 3PLs
        </p>
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8">
          {trustSignals.map((signal, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-navy-600 text-sm md:text-base"
            >
              <svg className="w-4 h-4 text-amber-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
              </svg>
              <span>{signal}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
